import { createFileRoute } from '@tanstack/react-router'
import { ShipmentDetailPage } from '@/pages/shipment-detail'

export const Route = createFileRoute('/_authenticated/shipments/$shipmentId')({
  staticData: { title: 'Shipment' },
  component: ShipmentDetailRoute,
})

function ShipmentDetailRoute() {
  const { shipmentId } = Route.useParams()
  return <ShipmentDetailPage shipmentId={shipmentId} />
}
